import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, Badge, Spinner } from 'react-bootstrap';
import { getJobs } from '../api/jobs';
import SettingsContext from '../context/SettingsContext';
import dayjs from 'dayjs';

const BayStatus = ({ refreshTrigger }) => {
    const { settings } = useContext(SettingsContext);
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);
    const bayCount = settings?.bay_count || 1;

    useEffect(() => {
        const fetch = async () => {
            setLoading(true);
            try {
                const todayStart = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const todayEnd = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                const data = await getJobs(todayStart, todayEnd);
                setReservations(data);
            } catch (err) {
                console.error('BayStatus fetch error:', err);
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, [refreshTrigger]);

    if (loading) return <div className="text-center my-2"><Spinner animation="border" size="sm" /></div>;

    return (
        <Row className="g-2 mb-4">
            {[...Array(bayCount)].map((_, i) => {
                const bay = i + 1;

                const current = reservations.find(r => r.bayNumber === bay && r.status === 'in_progress');

                const nextRes = reservations
                    .filter(r =>
                        r.bayNumber === bay &&
                        (r.status === 'confirmed' || r.status === 'pending')
                    )
                    .sort((a, b) => dayjs(a.startTime).unix() - dayjs(b.startTime).unix())[0];

                return (
                    <Col key={bay} xs={6} md={Math.max(2, Math.floor(12 / bayCount))}>
                        <Card className="h-100 border-0 shadow-sm">
                            <Card.Body className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-bold">베이 {bay}</span>
                                    <Badge bg={current ? 'info' : 'success'} className="fw-normal">
                                        {current ? '작업중' : '비어있음'}
                                    </Badge>
                                </div>

                                <div className="small text-truncate">
                                    {current ? (
                                        <span className="fw-bold text-dark">
                                            {current.plateNumber || current.customerName || '-'}
                                        </span>
                                    ) : (
                                        <span className="text-muted">—</span>
                                    )}
                                </div>

                                <div className="mt-2 text-muted" style={{ fontSize: '0.72rem' }}>
                                    {nextRes ? (
                                        <>다음 <strong>{dayjs(nextRes.startTime).format('HH:mm')}</strong> {nextRes.customerName}</>
                                    ) : (
                                        '이후 예약 없음'
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default BayStatus;
